import React from 'react';
import { Select } from 'antd';
import { SelectProps } from 'antd/es/select';
import { redemptionLimitsOptions } from 'entities/Promo/Promo.const';

interface IComponentProps {
  onChange?: (value: boolean) => void;
}

type AllProps = SelectProps<any> & IComponentProps;

export const RedemptionLimitSelector: React.FC<AllProps> = ({ value, onChange }) => {
  const handleChange = (value: boolean) => {
    onChange && onChange(value);
  };

  return (
    <Select
      className="width-full"
      value={value}
      defaultValue={false}
      defaultActiveFirstOption={true}
      onChange={(value: boolean) => handleChange(value)}
    >
      <Select.Option value={redemptionLimitsOptions.single.value} label={redemptionLimitsOptions.single.label}>
        {redemptionLimitsOptions.single.label}
      </Select.Option>
      <Select.Option value={redemptionLimitsOptions.multiple.value} label={redemptionLimitsOptions.multiple.label}>
        {redemptionLimitsOptions.multiple.label}
      </Select.Option>
    </Select>
  );
};
